import { CreateUserCommand, UpdateUserCommand } from '@admin/app/api'
import { UserFormProfile } from '../models/user-form.profile'

const mapFormValuesToCreateDto = ({
  email,
  firstName,
  lastName,
  isSuperUser,
  tenantId,
}: UserFormProfile): CreateUserCommand => ({
  email,
  firstName,
  lastName,
  isSuperuser: isSuperUser,
  tenantId: tenantId ? +tenantId : null,
})

const mapFormValuesToUpdateDto = ({
  id,
  email,
  firstName,
  lastName,
  isSuperUser,
  tenantId,
}: UserFormProfile): UpdateUserCommand => ({
  userId: id!,
  email,
  firstName,
  lastName,
  isSuperuser: isSuperUser,
  tenantId: tenantId ? +tenantId : null,
})

export const UserFormMapper = {
  mapFormValuesToCreateDto,
  mapFormValuesToUpdateDto,
}
